import type { Message } from '@entities/post'
import { MessageType } from '@entities/post/model/types'
import useMobileView from '@shared/hooks/isMobile'
import { classNames } from '@shared/lib/classNames'
import type { UploadFile } from 'antd'
import { Image, Typography } from 'antd'
import * as styles from './message-view.module.scss'

const { Text } = Typography

interface messageProps {
    message: Message
}

const mappingAlbum = (file: UploadFile) => {
    const {
        response: { file_name, file_type, file_url }
    } = file
    switch (file_type) {
        case MessageType.PHOTO:
            return <Image src={file_url} />
        case MessageType.VIDEO:
            return (
                <>
                    <video style={{ width: '100%' }} controls>
                        <source src={file_url} />
                        Your browser does not support the video tag. Ваш браузер не поддерживает аудио-плеер.
                    </video>
                </>
            )
        case MessageType.AUDIO || MessageType.VOICE:
            return (
                <>
                    <span style={{ margin: '10px 0 5px 0', display: 'inline-block' }}>{file_name}</span>
                    <audio style={{ width: '100%' }} controls>
                        <source src={file_url} />
                        Your browser does not support the video tag. Ваш браузер не поддерживает аудио-плеер.
                    </audio>
                </>
            )
        case MessageType.DOCUMENT:
            return <Text> Документ: {file_name} </Text>
        default:
            return <div>Превью недоступен</div>
    }
}

export const MessageView = ({ message }: messageProps) => {
    const { isCaptionAbove, messageType, file, id, text, options, question } = message

    const isMobile = useMobileView()

    const Caption = ({ text }: { text: string }) => (
        <div
            className={classNames('', { [styles.mobileTextContainer]: isMobile })}
            dangerouslySetInnerHTML={{ __html: text }}
        />
    )

    switch (messageType) {
        case MessageType.PHOTO:
            return (
                <>
                    {isCaptionAbove && <Caption text={text} />}
                    {file.map((file) => (
                        <Image key={file.response.id} src={file.response.file_url} />
                    ))}
                    {!isCaptionAbove && <Caption text={text} />}
                </>
            )
        case MessageType.VIDEO:
            return (
                <>
                    {isCaptionAbove && <Caption text={text} />}
                    {file.map((file, index) => (
                        <video style={{ width: '100%' }} controls key={index}>
                            <source src={file.response.file_url} />
                            Your browser does not support the video tag. Ваш браузер не поддерживает аудио-плеер.
                        </video>
                    ))}
                    {!isCaptionAbove && <Caption text={text} />}
                </>
            )
        case MessageType.AUDIO || MessageType.VOICE:
            return (
                <>
                    {isCaptionAbove && <Caption text={text} />}
                    {file.map((file) => (
                        <>
                            <span style={{ margin: '10px 0 5px 0', display: 'inline-block' }}>
                                {file?.response.file_name}
                            </span>
                            <audio style={{ width: '100%' }} controls>
                                <source src={file?.response?.file_url} />
                                Your browser does not support the video tag. Ваш браузер не поддерживает аудио-плеер.
                            </audio>
                        </>
                    ))}
                    {!isCaptionAbove && <Caption text={text} />}
                </>
            )
        case MessageType.DOCUMENT:
            return (
                <>
                    <>
                        {isCaptionAbove && <Caption text={text} />}
                        {file.map((file) => (
                            <div key={file.response.id}>
                                <Text key={file.response.id}> Документ: {file.response.file_name} </Text>
                            </div>
                        ))}
                        {!isCaptionAbove && <Caption text={text} />}
                    </>
                </>
            )
        case MessageType.QUIZ:
            return (
                <>
                    <Text strong>Вопрос: {question}</Text>
                    {options?.map((item, index) => (
                        <Text type="warning" key={index}>
                            Вариант {index + 1}: {item}
                        </Text>
                    ))}
                </>
            )
        case MessageType.TEXT:
            return <div dangerouslySetInnerHTML={{ __html: text }} />

        case MessageType.ALBUM:
            return (
                <>
                    {isCaptionAbove && <div dangerouslySetInnerHTML={{ __html: text }} />}
                    {file.map((file) => mappingAlbum(file))}
                    {!isCaptionAbove && <div dangerouslySetInnerHTML={{ __html: text }} />}
                </>
            )
        default:
            return <div>Превью недоступен</div>
    }
}
